<div class="kv">
  <!-- A beállított kapcsolat -->
  <div class="kv-aktualis" *ngIf="allapot?.aktualis as k" [class.rossz]="k.allapot !== 'aktiv' || k.utolso_hiba">
    <div class="kv-sor">
      <b>{{ k.tars_nev || 'Másik intézmény' }}</b>
      <span class="kv-cimke" [class.ki]="k.allapot !== 'aktiv'">{{ k.allapot === 'aktiv' ? (k.helyi ? 'kapcsolat · ez az installáció' : 'kapcsolat · másik installáció') : 'megszüntetve' }}</span>
      <span class="kv-ter"></span>
      <button type="button" class="kv-link" (click)="levalaszt()" [disabled]="fut">Leválasztás</button>
    </div>
    <div class="kv-apro">
      Adatkörök: {{ k.hatokorok?.length ? (k.hatokorok.map(hatokorNev).join(', ')) : '—' }}
      <ng-container *ngIf="k.utolso_hasznalat"> · utoljára: {{ k.utolso_hasznalat | date:'yyyy.MM.dd. HH:mm' }}</ng-container>
      <ng-container *ngIf="k.tars_verzio"> · a másik oldal verziója: {{ k.tars_verzio }}</ng-container>
    </div>
    <div class="kv-figy" *ngIf="k.figyelmeztetes">{{ k.figyelmeztetes }}</div>
    <div class="kv-hiba" *ngIf="k.allapot !== 'aktiv'">Az adatgazda megszüntette a kapcsolatot – kérj tőle új kapcsolati kódot.</div>
    <div class="kv-hiba" *ngIf="k.allapot === 'aktiv' && k.utolso_hiba">Legutóbbi hiba: {{ k.utolso_hiba }}</div>
  </div>

  <!-- Meglévő kapcsolat választása -->
  <label class="kv-mezo" *ngIf="valaszthato.length">
    <span>Meglévő kapcsolat</span>
    <select [ngModel]="''" (ngModelChange)="valaszt($event)" [disabled]="fut">
      <option value="">— válassz —</option>
      <option *ngFor="let v of valaszthato" [value]="v.id">{{ v.tars_nev || v.tars_intezmeny }} · {{ v.hatokorok.map(hatokorNev).join(', ') }}</option>
    </select>
  </label>

  <!-- Új kapcsolat kóddal -->
  <div class="kv-uj">
    <label class="kv-mezo">
      <span>{{ allapot?.aktualis ? 'Új kapcsolati kód' : 'Kapcsolati kód' }}</span>
      <input [(ngModel)]="kod" placeholder="pl. FP7UH-7SH4-B4CK-ZLE2-R57V" autocapitalize="characters" spellcheck="false" (keydown.enter)="csatlakozik()">
    </label>
    <label class="kv-mezo" *ngIf="kezi">
      <span>A másik rendszer címe</span>
      <input [(ngModel)]="url" placeholder="https://erp.iskola.hu" autocapitalize="off" spellcheck="false">
    </label>
    <div class="kv-gombok">
      <button type="button" class="kv-gomb" (click)="csatlakozik()" [disabled]="fut || !kod.trim()">{{ fut ? 'Kapcsolódás…' : 'Kapcsolódás' }}</button>
      <button type="button" class="kv-link" (click)="kezi = !kezi">{{ kezi ? 'cím nélkül (címjegyzékből)' : 'a másik rendszer címének megadása' }}</button>
    </div>
    <p class="kv-sugo">A kódot az adatgazda intézmény adminja adja (Admin → Kapcsolatok). Ha a két intézmény különböző rendszeren van,
      a kód beírása után az adat onnan jön; a kapcsolat csak olvas, és az adatgazda bármikor megszüntetheti.</p>
  </div>
  <div class="kv-ok" *ngIf="uzenet">{{ uzenet }}</div>
  <div class="kv-hiba" *ngIf="hiba">{{ hiba }}</div>
</div>
